// Fichier : app/javascript/controllers/calculator_controller.js
import { Controller } from "@hotwired/stimulus";
import { evaluate } from "../lib/safe_arithmetic";

export default class extends Controller {
  static targets = ["display", "history"];

  connect() {
    this.current = "";
    this.lastEvaluated = false;
    this.updateDisplay("0");
    this.updateHistory("");
  }

  append(event) {
    const val = event.currentTarget.dataset.value;
    if (this.lastEvaluated) {
      this.current = "";
      this.updateHistory("");
      this.lastEvaluated = false;
    }
    if (val === "." && this.current.slice(-1) === ".") return;
    if (this.current === "Erreur") this.current = "";
    this.current += val;
    this.updateDisplay(this.current);
  }

  operator(event) {
    const op = event.currentTarget.dataset.value;
    if (!this.current && op !== "-") return;
    if (/[+\-*/]$/.test(this.current)) {
      this.current = this.current.slice(0, -1) + op;
    } else {
      try {
        const res = evaluate(this.current);
        this.current = res.toString() + op;
      } catch {
        this.current = "Erreur";
      }
    }
    this.lastEvaluated = false;
    this.updateDisplay(this.current);
  }

  evaluate() {
    if (!this.current) return;
    try {
      const result = evaluate(this.current);
      this.updateHistory(`${this.current} =`);
      this.current = result.toString();
      this.updateDisplay(this.current);
      this.lastEvaluated = true;
    } catch {
      this.current = "Erreur";
      this.updateDisplay(this.current);
      this.lastEvaluated = false;
    }
  }

  clear() {
    this.current = "";
    this.lastEvaluated = false;
    this.updateDisplay("0");
    this.updateHistory("");
  }

  backspace() {
    if (this.current && this.current !== "Erreur") {
      this.current = this.current.slice(0, -1);
      this.updateDisplay(this.current);
    } else {
      this.current = "";
      this.updateDisplay("0");
    }
    this.lastEvaluated = false;
  }

  keydown(event) {
    const target = event.target;
    if (
      target &&
      (target.tagName === "INPUT" ||
        target.tagName === "TEXTAREA" ||
        target.isContentEditable)
    ) {
      return; // let editable fields handle their own keystrokes
    }
    const key = event.key;
    if (/^[0-9]$/.test(key) || key === ".") {
      event.preventDefault();
      this.append({ currentTarget: { dataset: { value: key } } });
    }
    if (["+", "-", "*", "/"].includes(key)) {
      event.preventDefault();
      this.operator({ currentTarget: { dataset: { value: key } } });
    }
    if (key === "Enter") {
      event.preventDefault();
      this.evaluate();
    }
    if (key === "Backspace") {
      event.preventDefault();
      this.backspace();
    }
    if (key === "Escape") {
      event.preventDefault();
      this.clear();
    }
  }

  updateDisplay(value) {
    this.displayTarget.textContent = value || "0";
  }

  updateHistory(expr) {
    this.historyTarget.textContent = expr || "";
  }

  copyResult() {
    const value = this.displayTarget.textContent?.trim() || "0";
    navigator.clipboard.writeText(value).then(() => this.showCopiedToast());
  }

  showCopiedToast() {
    const toast = document.createElement("div");
    toast.className =
      "alert alert-success shadow-lg fixed bottom-4 right-4 z-50 text-sm";
    toast.setAttribute("role", "status");
    toast.innerHTML = "<span>Copié !</span>";
    document.body.appendChild(toast);
    setTimeout(() => toast.remove(), 2500);
  }
}
